// extracted by mini-css-extract-plugin
export var thumbDown = "Feedback-module--thumbDown--66e8b";
export var thumbUp = "Feedback-module--thumbUp--e0f4b";
export var thumbWrapper = "Feedback-module--thumbWrapper--af81b";